// De 3 bedste Facebook-anmeldelser fra NS Tømrer og Ejendomsservice — udvalgt for specifikke projektdetaljer.
export const testimonials = [
    {
        name: "Kalyan Adhikari",
        date: "8. april",
        text: "Nicklas leverer et meget professionelt stykke arbejde. Han har blandt andet hjulpet med opsætning af klatrevæg, hegn, havelåge, og resultatet var både solidt og flot udført. Derudover er han både venlig, imødekommende og meget pålidelig. Kvalitetsarbejde blev udført til tiden som aftalt. Jeg vil uden tvivl benytte mig af NS Tømrer og Ejendomsservice igen i fremtiden og kan klart anbefale ham til andre.",
    },
    {
        name: "Charlotte Højgaard Siepmann",
        date: "19. april",
        text: "Fik skiftet lister på mine vinduer. Flot arbejde og en rigtig fornuftig pris. God orientering undervejs. Jeg giver mine varmeste anbefalinger.",
    },
    {
        name: "Hanne Knudsen",
        date: "3. december 2025",
        text: "Super godt firma, hjalp mig med at få lagt nye gulve, og en helt ny terrasse. Nicklas var nem at snakke med, og fik det en super god pris.",
    },
];
